// Centralized API URL resolution
// Detects stale build URLs and uses current origin instead — EXCEPT during react-snap
// pre-rendering (puppeteer sirve el build en localhost:XXXX y NO tiene backend, entonces
// hay que usar el REACT_APP_BACKEND_URL real).
var _envUrl = process.env.REACT_APP_BACKEND_URL;
var _isReactSnap = typeof navigator !== 'undefined' && /ReactSnap|HeadlessChrome/i.test(navigator.userAgent || '');
var API_BASE;
if (typeof window !== 'undefined' && _envUrl) {
  if (_isReactSnap) {
    // Durante snapshot: usar el URL de env sin importar el hostname del server local
    API_BASE = _envUrl + '/api';
  } else if (!_envUrl.includes('localhost') && !_envUrl.includes(window.location.hostname)) {
    // Cliente real con URL stale (build viejo): usar current origin
    API_BASE = window.location.origin + '/api';
  } else {
    API_BASE = _envUrl + '/api';
  }
} else {
  API_BASE = _envUrl ? _envUrl + '/api' : '/api';
}

export var API = API_BASE;
export default API;
